module.exports = __webpack_public_path__ + "static/image4.da66be46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project1/image4.jpg
// module id = 132
// module chunks = 100667300852966 131627143932366